// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__3JcEb","hover-typeB-r":"panel_hover-typeB-r__2TgC_"};